import { api } from '@/api/api-client.config.ts';
import { useMutation } from '@tanstack/react-query';

const getPickemLeaderboardCSV = (pickemId: number): Promise<BlobPart> =>
  api.get(`/admin/leaderboard/export-csv/${pickemId}`, {
    responseType: 'blob',
  });

export const useGetPickemLeaderboardCSVMutation = (pickemId: number) => {
  return useMutation({
    mutationKey: ['getPickemLeaderboardCSV', pickemId],
    mutationFn: () => getPickemLeaderboardCSV(pickemId),
  });
};
